import { render, staticRenderFns } from "./SelectedPrice.vue?vue&type=template&id=6eadce06&scoped=true"
import script from "./SelectedPrice.vue?vue&type=script&lang=js"
export * from "./SelectedPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eadce06",
  null
  
)

export default component.exports